import React from 'react';

import { Service } from '@hud/portal-dtos/webapp-service.dto';

import { Container } from '@hud/web-components/Container/Container';
import DataColumns from '@hud/web-components/DataColumns/DataColumns';
import RunningStatus from '@hud/web-components/RunningStatus/RunningStatus';
import { formatDateTime } from '@hud/web-components/utils';
import { RuntimeLabel } from '@hud/web-components/Runtime/RuntimeLabel';

export interface ServiceOverviewProps {
  service?: Service;
  loading: boolean;
}

export default function ServiceOverview({
  service,
  loading,
}: ServiceOverviewProps) {
  return (
    <Container variant="filled" title="Overview" icon="webviewMenu.info" aria-label="Service Overview">
      <DataColumns.WrappableColumns>
        <DataColumns.Column>
          <DataColumns.Row title="Status" loading={loading}>
            {service ? <RunningStatus status={service.state} /> : null}
          </DataColumns.Row>

          <DataColumns.Row title="Functions mapped" loading={loading}>
            {service?.totalFunctions}
          </DataColumns.Row>
        </DataColumns.Column>
        <DataColumns.Column>
          <DataColumns.Row title="Last seen" loading={loading}>
            {service?.lastSeenAt
              ? formatDateTime(service.lastSeenAt, true)
              : '-'}
          </DataColumns.Row>
          <DataColumns.Row title="Language" loading={loading}>
            {service?.runtime ? (
              <RuntimeLabel runtime={service.runtime} />
            ) : null}
          </DataColumns.Row>
        </DataColumns.Column>
      </DataColumns.WrappableColumns>
    </Container>
  );
}
